import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateUncontrolledRiskOversightResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateUncontrolledRiskOversightResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type UpdateUncontrolledRiskOversightResultInput = {
  Id: string;
  Impact?: number | null;
  Likelihood?: number | null;
  Rating?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateUncontrolledRiskOversightResult = createMutationHook({
  name: 'updateUncontrolledRiskOversightResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.assessment.updateUncontrolledRiskOversightResult.mutationOptions(
      { onSuccess }
    ),
  mapInput: (input: UpdateUncontrolledRiskOversightResultInput) => input,
  invalidate: (trpc) => [
    // Apollo parity: evictField(cache, 'risk_uncontrolled_oversight_result')
    trpc.frontend.assessment.getOversightResultsByParentId.pathKey(),
    trpc.frontend.assessment.getAllOversightAssessmentResults.queryKey(),
    trpc.frontend.assessment.oversightResultById.pathKey(),
    trpc.frontend.assessment.riskOversightResultById.pathKey(),
    trpc.frontend.assessment.oversightAssessmentRiskAssessmentResultsByRiskId.pathKey(),
    trpc.frontend.assessment.latestOversightAssessmentRiskAssessmentResultsByRiskId.pathKey(),
    // Apollo parity: evictField(cache, 'risk_uncontrolled_oversight_result_aggregate')
    trpc.frontend.assessment.oversightAssessmentResultCount.queryKey(),
    // Apollo parity: evictField(cache, 'oversight_assessment')
    trpc.frontend.assessment.oversightActivityRegister.queryKey(),
    trpc.frontend.assessment.oversightActivityCount.queryKey(),
  ],
  mapResponse: (): UpdateUncontrolledRiskOversightResultMutation => ({
    update_risk_uncontrolled_oversight_result: {
      __typename: 'risk_uncontrolled_oversight_result_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateUncontrolledRiskOversightResultDocument,
  graphqlVariables: (input: UpdateUncontrolledRiskOversightResultInput) => ({
    Id: input.Id,
    Impact: input.Impact,
    Likelihood: input.Likelihood,
    Rating: input.Rating,
    Rationale: input.Rationale,
    TestDate: input.TestDate,
    CustomAttributeData: input.CustomAttributeData ?? null,
  }),
  evictFields: [
    'oversight_assessment',
    'risk_uncontrolled_oversight_result',
    'risk_uncontrolled_oversight_result_aggregate',
  ],
});
